module.exports = __webpack_public_path__ + "static/php-a36bcf5ef9e9bc4873285146818a7c85.png";